import 'leaflet.heat'
import 'leaflet/dist/leaflet.css'
import { DragDrop } from '@src/components/DragDrop/DragDrop'
import { ProgressBar } from '@src/components/ProgressBar/ProgressBar'
import { lang } from '@src/lang'
import { Button, Container, Flex, SimpleGrid } from '@chakra-ui/react'
import { DataListComponent } from '@src/components/DataListComponent/DataListComponent'
import { CardComponent } from '@src/components/CardComponent/CardComponent'
import { BarChartComponent } from '@src/components/BarChartComponent/BarChartComponent'
import { capitalizeFirstLetter, roundNumber } from '@src/helpers/utils'
import { observer } from 'mobx-react-lite'
import { toJS } from 'mobx'
import { useMainPageLogic } from '@src/pages/hooks/useMainPageLogic'
import { fieldToLabel, fieldToMeasure } from '@src/pages/MainPageStore'
import { FilePreviewList } from '@src/components/FilePreviewList/FilePreviewList'
import { YMapComponent } from '@src/components/Map/YMapComponent'

export const MainPage = observer(() => {
    const { store, handleFiles, handleFilesByLink } = useMainPageLogic()

    return (
        <Container fluid paddingInline={6} paddingBlock={4}>
            <Flex direction={'column'} gap={4}>
                <DragDrop handleFileInput={handleFiles} handleLink={handleFilesByLink} />
                {store.progress.total > 0 && (
                    <>
                        <ProgressBar
                            completed={store.progress.completed}
                            total={store.progress.total}
                        />
                        <FilePreviewList files={store.totalFiles}></FilePreviewList>
                    </>
                )}

                <SimpleGrid className="dashboard-grid" gap="40px">
                    <Flex direction={'column'} gap="24px" minW="0">
                        <SimpleGrid columns={{ base: 1, sm: 2 }} gap="40px">
                            <CardComponent title={lang.trashByTypes}>
                                <DataListComponent
                                    data={[...store.trashTypes.entries()].map(([type, count]) => ({
                                        label: capitalizeFirstLetter(type),
                                        value: `${count} ${lang.itemsMeasure}`,
                                    }))}
                                />
                            </CardComponent>
                            <CardComponent title={lang.trashByValues}>
                                <DataListComponent
                                    data={Object.keys(store.totalValues).map(key => ({
                                        label: fieldToLabel[key],
                                        value: `${roundNumber(store.totalValues[key])} ${fieldToMeasure[key]}`,
                                    }))}
                                />
                            </CardComponent>
                        </SimpleGrid>
                        <SimpleGrid columns={{ base: 1, sm: 3 }} gap={'40px'}>
                            <CardComponent title={lang.area}>
                                <BarChartComponent
                                    data={toJS(store.areaData)}
                                    series={[{ name: 'value', color: 'purple.400' }]}
                                />
                            </CardComponent>
                            <CardComponent title={lang.mass}>
                                <BarChartComponent
                                    data={toJS(store.massData)}
                                    series={[{ name: 'value', color: 'blue.500' }]}
                                />
                            </CardComponent>
                            <CardComponent title={lang.volume}>
                                <BarChartComponent
                                    data={toJS(store.volumeData)}
                                    series={[{ name: 'value', color: 'teal.solid' }]}
                                />
                            </CardComponent>
                        </SimpleGrid>
                    </Flex>
                    <div className="dashboard-map">
                        <YMapComponent markers={store.mapMarkers} />
                    </div>
                    {/* <MapComponent points={store.mapPoints} markers={store.mapMarkers} /> */}
                </SimpleGrid>
            </Flex>
        </Container>
    )
})
